import { format } from 'date-fns';
import { DatesRange } from '@utils/types/calendar';
import config from '@utils/config/env';
import { ListingPriceEstimateType } from '@utils/types/estimate';

export async function getListingPriceRequest(props: {
  listingId: string;
  dateStart: DatesRange['from'];
  dateEnd: DatesRange['to'];
  paymentMethod?: Object;
  discountCode?: string;
  withPetFee?: boolean;
  upsellAlternative?: string;
}): Promise<ListingPriceEstimateType> {
  const {
    listingId,
    dateStart,
    dateEnd,
    paymentMethod,
    discountCode,
    withPetFee,
    upsellAlternative,
  } = props;
  const res = await fetch(`${config.backendBaseUrl}/v2/booking/estimate`, {
    method: 'POST',
    headers: {
      'kopa-api-key': config.backendAPIKey,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      start: dateStart ? format(new Date(dateStart), `yyyy-MM-dd`) : dateStart,
      end: dateEnd ? format(new Date(dateEnd), `yyyy-MM-dd`) : dateEnd,
      listing_id: listingId,
      payment_method: paymentMethod,
      voucher: discountCode,
      pet_fee: withPetFee || false,
      upsell_alternative: upsellAlternative,
    }),
  });

  return await res.json();
}
